import { Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';
import RetainerWizardFromBank from './RetainerWizardFromBank/RetainerWizardFromBank';
import RetainerWizardNoBank from './RetainerWizardNoBank/RetainerWizardNoBank';

function RetainerWizardModal({
  open,
  handleCloseModal,
  currentPatient = null,
  handleOpenManageSubscription,
}) {
  return currentPatient ? (
    <Modal open={open} setOpen={handleCloseModal} size="5xl">
      <div className="p-0">
        {currentPatient.retainerBank > 0 && currentPatient.hasPlan && (
          <RetainerWizardFromBank
            patient={currentPatient}
            handleCloseModal={handleCloseModal}
          />
        )}

        {currentPatient.retainerBank <= 0 && currentPatient.hasPlan && (
          <RetainerWizardNoBank
            patient={currentPatient}
            handleCloseModal={handleCloseModal}
            handleOpenManageSubscription={handleOpenManageSubscription}
          />
        )}
      </div>
    </Modal>
  ) : null;
}

RetainerWizardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  currentPatient: PropTypes.object,
  handleOpenManageSubscription: PropTypes.func,
};

export default RetainerWizardModal;
